import { Link } from 'react-router-dom';

export default function AboutPage() {
  return (
    <div className="ab-page">
      <article className="ab-story">

        <header className="ab-story-header">
          <span className="ab-eyebrow">The story</span>
          <h1 className="ab-story-title">
            From 1200 to 2200,<br />one bad loss at a time.
          </h1>
        </header>

        <div className="ab-story-body">
          <p className="ab-story-p ab-story-p--lead">
            I learned chess as a kid. Basic moves, basic traps, never actually
            studied. Then COVID happened, and like a lot of people in 2020,
            I picked it back up.
          </p>

          <p className="ab-story-p">
            I was a 1200 rapid player. I thought that was fine.
          </p>

          <p className="ab-story-p">
            Then a friend destroyed me. Not close. I ran the post-game
            analysis, and it was embarrassing. Every mistake flagged. Every
            missed tactic highlighted. I could not argue with the data.
          </p>

          <p className="ab-story-p">
            I vowed to get better.
          </p>

          <p className="ab-story-p">
            That vow turned into an obsession with patterns. What openings
            was I actually good at? When did I tend to blunder? How much
            time was I spending per game? The Chess.com interface never gave
            me those answers cleanly, so I built something that did.
          </p>

          <p className="ab-story-p">
            ChessLytics started as a personal tool. Pull my games, run the
            numbers, find the patterns. It grew from there.
          </p>

          <div className="ab-rating-glow">
            <div className="ab-rating-then">
              <span className="ab-rating-num">1200</span>
              <span className="ab-rating-label">Rapid, 2020</span>
            </div>
            <div className="ab-rating-arrow" aria-hidden>→</div>
            <div className="ab-rating-now">
              <span className="ab-rating-num">2200</span>
              <span className="ab-rating-label">Rapid, today</span>
            </div>
          </div>

          <p className="ab-story-p">
            1000 rating points in a few years. I am proud of that.
          </p>

          <p className="ab-story-p ab-story-p--closing">
            If you want to see your own patterns, run a report.
            No account. Just your Chess.com username.
          </p>

          <Link to="/wrapped" className="ab-story-cta">
            Run your Year in Review →
          </Link>
        </div>

        <footer className="ab-story-footer">
          <span className="ab-story-sig">Edward Lai</span>
          <span className="ab-story-sig-note">
            <a
              href="https://www.chess.com/member/edwardl903"
              target="_blank"
              rel="noopener noreferrer"
              className="ab-story-link"
            >
              EdwardL903
            </a>{' '}
            on Chess.com
          </span>
        </footer>

      </article>
    </div>
  );
}
